var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayCtaFilled = function SvgPlayCtaFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.47 12.137a2.479 2.479 0 0 1-1.28 2.147L5.268 23.123a2.536 2.536 0 0 1-2.488-.018 2.479 2.479 0 0 1-1.25-2.143V3.038c0-.888.485-1.71 1.262-2.151a2.541 2.541 0 0 1 2.502.004l15.921 9.086a2.477 2.477 0 0 1 1.254 2.16Z",
    fill: "currentColor"
  })));
};
export default SvgPlayCtaFilled;